import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button']

  static values = {
    stateClasses: Object
  }

  setActiveState(e) {
    const buttonToActivate = e.currentTarget

    this.buttonTargets.forEach(button => {
      if (button === buttonToActivate) {
        button.classList.remove(...this.stateClassesValue.inactive)
        button.classList.add(...this.stateClassesValue.active)
      } else {
        button.classList.remove(...this.stateClassesValue.active)
        button.classList.add(...this.stateClassesValue.inactive)
      }
    })
  }
}
